<div class="flex vcenter menu-buttons">
  <button
    payee-button
    width="shorter"
    routerLink="case-starts"
  >
    Ügyindítások
  </button>
  <button
    payee-button
    routerLink="soft-paid"
  >
    Sikeres Fizetési Felszólítások
  </button>
</div>

<router-outlet></router-outlet>
